import React from "react";
import simpleicon from "../../Assets/Images/simpleProcessIcon.png";
import guidenceicon from "../../Assets/Images/expertGuidenceIcon.png";
import fastresulticon from "../../Assets/Images/fastResultsIcon.png";
const ExperienceCards = () => {
  return (
    <div className="container">
      <div className="contact-cards">
        <h2 className="contact-cards-heading">Hassle-Free Experience</h2>
          <div className="experience-cards">
        <div className="experience-card">
          <img className="simple-icon" src={simpleicon} alt="" />
          <h1>Simple Process</h1>
          <p>
            We streamline every step of ISO certification, making the entire
            process easy, stress-free, and efficient for your business.
          </p>
        </div>

        <div className="experience-card  ">
          <img className="simple-icon" src={guidenceicon} alt="" />
          <h1>Expert Guidence</h1>
          <p>
            Our experienced consultants provide clear instructions, personalised
            solutions, and dedicated support at every stage from start to
            finish.
          </p>
        </div>

        <div className="experience-card">
          <img className="fast-result-icon" src={fastresulticon} alt="" />
          <h1>Fast Results</h1>
          <p>
            We help you achieve certification quickly and efficiently, without
            compromising on quality, or industry standards.
          </p>
        </div>
      </div>
      </div>
    </div>
  );
};

export default ExperienceCards;
